import { createContext } from 'react';
import { initialState } from './MessageBar.constants';
import { tMessageBarContext } from './MessageBar.types';

export const MessageBarContext =
  createContext<tMessageBarContext>(initialState);
